import { RootState } from 'gf-types';
import { Dispatch } from 'redux';

export interface AppContext {
  store: ReduxStore;
  previewCompleted?: boolean;
  // todo - this should live in the redux store in the onboarding slice
  onboardingSurveyCompleted?: boolean;
}

type ReduxStore = {
  getState: () => RootState;
  dispatch: Dispatch;
};

export const appContext: Partial<AppContext> = {};
